import React, { Dispatch, SetStateAction, useState } from 'react';

import { useParams } from 'react-router-dom';
import { useQuery } from 'react-query';
import Swal from 'sweetalert2';

import { ICustomerData, IServiceData } from 'src/environments/Checkout/interfaces';
import { apiCheckout } from 'src/environments/Checkout/api';

import CreditCardForm from './components/CreditCardForm';

import ConcludePurchase from './components/ConcludePurchase';

import loadingGIF from '../../../../../../../../assets/gifs/loading.png';
import { LoadingGif } from './style';

type Props = {
  customerData: ICustomerData;
  serviceData: IServiceData;
  platform: string;
  setShowPaymentMethod: Dispatch<SetStateAction<string>>;
  couponId: number;
};

export default function PurchasePaymentCreditCard({
  customerData,
  serviceData,
  platform,
  setShowPaymentMethod,
  couponId,
}: Props): JSX.Element {
  const [showCardForm, setShowCardForm] = useState(false);

  const { token } = useParams();

  const {
    isLoading: loadingCardsIds,
    isError,
    data: cardsIds,
  } = useQuery(['getCardsIds', token], async () => apiCheckout.getCardsIds(token), {
    onError: () => {
      void Swal.fire({
        icon: 'error',
        title: 'Ocorreu um erro!',
        text: 'Por favor, tente novamente mais tarde, ou contate a central.',
        iconColor: 'black',
        confirmButtonColor: 'black',
      });
    },
    onSuccess: () => {},
    refetchOnWindowFocus: false,
  });

  if (loadingCardsIds || isError) {
    return <LoadingGif src={loadingGIF} alt="Loading spinning" />;
  }

  return (
    <>
      {showCardForm || cardsIds.length === 0 ? (
        <CreditCardForm
          customerData={customerData}
          setShowCardForm={setShowCardForm}
          hasCards={cardsIds.length > 0}
          setShowPaymentMethod={setShowPaymentMethod}
        />
      ) : (
        <ConcludePurchase
          customerData={customerData}
          setShowCardForm={setShowCardForm}
          cardsIds={cardsIds}
          serviceData={serviceData}
          platform={platform}
          setShowPaymentMethod={setShowPaymentMethod}
          couponId={couponId}
        />
      )}
    </>
  );
}
